import { render, staticRenderFns } from "./FieldIconboxes.vue?vue&type=template&id=85da86dc&scoped=true&"
import script from "./FieldIconboxes.vue?vue&type=script&lang=js&"
export * from "./FieldIconboxes.vue?vue&type=script&lang=js&"
import style0 from "./FieldIconboxes.vue?vue&type=style&index=0&id=85da86dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85da86dc",
  null
  
)

export default component.exports